import React from 'react';
// template components
import BulletedList from '@nmx/template/dist/componentLibrary/components/BulletedList';
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';

export default () => (
  // span wrapper is necessary for the snapshot test to pick up all of the content. Fragments will fail
  <span>
    <SectionContainer
      id='client-relationship-summary-header'
      disableBottomPadding>
      <Row align='center'>
        <Col medium={8}>
          <Typography
            component='h1'
            nextElement='typography'>
            Client Relationship Summary &#8212; <WidowBlock>Form CRS</WidowBlock>
          </Typography>
          <Typography disableBottomPadding>
            Download:
          </Typography>
          <BulletedList
            bulletedListData={[
              {
                bulletText: <>
                  <Link
                    id='nmis-crs-client-relationship-link'
                    variant='primaryDeemphasize'
                    linkUrl='/assets/pdf/brochures/nmis-client-relationship.pdf'>
                    NMIS Client Relationship Summary <WidowBlock>&#40;Form CRS&#41;</WidowBlock>
                  </Link>
                  &#160;for brokerage services.
                </>,
              },
              {
                bulletText: <>
                  <Link
                    id='nmwmcs-client-relationship-link'
                    variant='primaryDeemphasize'
                    linkUrl='/assets/pdf/brochures/nmwmc-client-relationship.pdf'>
                    NMWMC Client Relationship Summary
                  </Link>
                  &#160;for investment advisory services.
                </>,
              },
            ]}
          />
          <Typography nextElement='typography'>
            The SEC&#39;s Form CRS and its related rules require registered broker&#45;dealers to deliver to retail investors a brief client relationship summary that provides information about the firm. Our CRS documents linked above follow the SEC&#39;s required formatting and content requirements, and are intended to help you with the
            process of deciding whether to:
          </Typography>
          <BulletedList
            bulletedListData={[
              { bulletText: 'establish an investment advisory or brokerage relationship,' },
              { bulletText: 'engage a particular firm or financial professional, or' },
              { bulletText: 'terminate or switch a relationship or specific service.' },
            ]}
          />
        </Col>
      </Row>
    </SectionContainer>
  </span>
);
